import Component from 'antd/es/tabs';
import 'antd/lib/tabs/style';
export default Component;

